<template>
    <v-container class="grey lighten-5" fluid>
        <v-row align="center" justify="center">
            <v-col md="6" sm="8" xs="12">
                <v-card>
                   <v-card-title class="px-3">Pay By Link</v-card-title>
                    <v-divider></v-divider>
                    <v-form ref="form" lazy-validation @submit="onSubmit">
                        <div class="px-4 py-2 pb-2">
                            <v-row>
                                <v-col md="12" sm="12" xs="12" class="py-0">
                                    <v-autocomplete
                                        v-model="form.channel"
                                        :items="channels"
                                        item-text="name"
                                        item-value="uuid"
                                        label="Channel"
                                        :rules="[rules.required]"
                                        @change="currencyHandle"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col md="12" sm="12" xs="12" class="py-0">
                                    <v-text-field
                                        v-model="form.senderId"
                                        label="Sender"
                                        :rules="[rules.required]"
                                        v-mask="masks.sender"
                                    ></v-text-field>
                                </v-col>
                                <v-col md="12" sm="12" xs="12" class="py-0">
                                    <v-text-field
                                        v-model="form.company"
                                        label="Company Name"
                                        :rules="[rules.required]"
                                        v-mask="masks.company"
                                    ></v-text-field>
                                </v-col>
                                <v-col md="12" sm="12" xs="12" class="py-0">
                                    <v-text-field
                                        v-model="form.merchantTransactionId"
                                        label="Reference"
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                </v-col>
                                <v-col md="12" sm="12" xs="12" class="py-0">
                                    <v-text-field
                                        v-model="form.email"
                                        label="Email Address"
                                        :rules="[validEmail, contactCheck]"
                                    ></v-text-field>
                                </v-col>
                                <v-col md="12" sm="12" xs="12" class="py-0">
                                    <v-text-field
                                        v-model="form.mobile"
                                        label="Mobile"
                                        :rules="[mobileCheck, contactCheck]"
                                    ></v-text-field>
                                </v-col>
                                <v-col md="12" sm="12" xs="12" class="py-0">
                                    <v-text-field
                                        v-model="form.amount"
                                        label="Amount"
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                </v-col>
                                <v-col md="12" sm="12" xs="12" class="py-0">
                                    <v-select
                                        v-model="form.currency"
                                        :items="currencies"
                                        :rules="[rules.required]"
                                        label="Currency"
                                    ></v-select>
                                </v-col>
                                <v-col md="12" sm="12" xs="12" class="py-0">
                                    <v-select
                                        v-model="form.autoSend"
                                        :items="autoSend"
                                        label="Auto Send"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </div>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" type="submit">Create</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>

                <v-col v-if="result && form.autoSend == 1" md="12" class="px-0">
                    <v-alert type="success" text border="left" dismissible class="mb-0" dense>
                        <div>
                            Successfully created & sent out Pay By Link.<br><br>
                            Pay By Link: https://control2.totalprocessing.com/pay-by-link-payment-cnp/{{ result.hash }}
                        </div>
                    </v-alert>
                </v-col>
                <v-col v-else-if="result && form.autoSend == 0" md="12" class="px-0">
                    <v-alert type="success" text border="left" dismissible class="mb-0" dense>
                        <div>
                            Successfully created Pay By Link.<br><br>
                            Pay By Link: https://control2.totalprocessing.com/pay-by-link-payment-cnp/{{ result.hash }}
                        </div>
                    </v-alert>
                </v-col>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';

export default {
    directives: { mask },
    data() {
        return {
            rules: {
                required: v => !!v || 'Required.',
            },
            form: { channel: null,
                    senderId: null,
                    company: null,
                    merchantTransactionId: null,
                    email: null,
                    mobile: null,
                    amount: null,
                    currency: null,
                    autoSend: 1 },
            channels: [],
            // currencies: [{ value: 'EUR', text: 'EUR' },
            //              { value: 'GBP', text: 'GBP' },
            //              { value: 'USD', text: 'USD' }],
            autoSend: [{ value: 1, text: 'Yes' },
                       { value: 0, text: 'No' }],
            result: null,
            masks: {
                sender: 'Aaaaaaaaaa',
                company: 'XXXXXXXXXXXXXXXXXXXX'
            },
        }
    },
    computed: {

    },
    beforeMount() {
        this.getChannels();
    },
    methods: {
        getChannels() {
            if(this.$store.state.user.user_role.id <= 3) {
                axios({
                method: 'get',
                url: `get-channels-live`,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    response.data.map(e => {
                        this.channels.push({ uuid: e.channelUuid, name: `${e.merchantName} - ${e.channelName}` });
                        let currencies = e.currencies.split(',');
                        this.channels.push({ uuid: e.channelUuid,
                                             name: `${e.merchantName} - ${e.channelName}`,
                                             currencies: currencies });
                    })
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else if(this.$store.state.user.user_role.id > 3) {
                axios({
                method: 'post',
                url: `get-channels-live-client`,
                data: { userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    response.data.map(e => {
                        let currencies = e.currencies.split(',');
                        // Total Jobs
                        if(e.merchantUuid == '8ac9a4ce7b593e13017b7361d3671bb7') {
                            if(e.channelUuid == '8ac9a4cc7b593e11017b7367842d0ad5') {
                                this.channels.push({ uuid: e.channelUuid,
                                                     name: `${e.merchantName} - ${e.channelName}`,
                                                     currencies: currencies });
                            }
                        }
                        // Everyone else
                        else {
                            this.channels.push({ uuid: e.channelUuid,
                                                 name: `${e.merchantName} - ${e.channelName}`,
                                                 currencies: currencies });
                        }
                    })
                    this.channels.sort(this.compare);
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        onSubmit(e) {
            e.preventDefault();
            if(this.$refs.form.validate()) {
                this.result = null;

                axios({
                method: 'post',
                url: 'send-pay-by-link',
                data: { form: this.form, userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.result = response.data;
                    console.log(this.result);
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        currencyHandle(a) {
            this.channels.find(e => { 
                if(e.uuid == a) {
                    this.currencies = e.currencies;
                }
            });
        },
        mobileCheck(e) {
            if(e) {
                // Allow UK and international numbers (e.164 format)

                // If length is 0 return true
                if (e.length == 0){
                    return true;
                }

                // If length is 11 and starts with a 0 return true
                if (e.length == 11 && e.startsWith('07')){
                    return true;
                }

                // If match e.164 format return true
                var re = new RegExp("^[+][1-9][0-9]{1,14}$");
                if (re.test(e)) {
                    return true;
                }

                // If here, then return invalid phone number
                return 'Invalid mobile number';
            }
            else {
                return true;
            }
        },
        validEmail(e)  {
            if(e) {
                let pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(e) || e.length == 0 ? true : 'Invalid email address.';
            }
            else {
                return true;
            }
        },
        contactCheck() {
            if(!this.form.email && !this.form.mobile) {
                return 'You must provide at least one method of contact.';
            }
            else {
                return true;
            }
        }
    }
}
</script>

<style>

</style>